import c from '@/config';

const state = {
  logged: window.localStorage.getItem('clientes-' + c.nombreCorto + '-logged') == "true" ? true : false,
  cambiarPass: window.localStorage.getItem('clientes-' + c.nombreCorto + '-cambiarPass') == "true" ? true : false,
  id: window.localStorage.getItem('clientes-' + c.nombreCorto + '-id') || null,
  email: window.localStorage.getItem('clientes-' + c.nombreCorto + '-email') || '',
  nombre: window.localStorage.getItem('clientes-' + c.nombreCorto + '-nombre') || '',
  token: window.localStorage.getItem('clientes-' + c.nombreCorto + '-token') || '',
  perfilUsuario: window.localStorage.getItem('clientes-' + c.nombreCorto + '-perfilusuario') || 1,
  error: ''
}

const getters = {
  credentials() {
    return state;
  }
}

const actions = {
  setToken(context, payload) {
    context.commit("setToken", payload);
  },
  setLogged(context, payload) {
    context.commit("setLogged", payload);
  },
  setCredentials(context, payload) {
    context.commit("setCredentials", payload);
  },
  clearCredentials(context) {
    context.commit("setCredentials", { token: '', id: '', nombre: '', email: '', logged: false });
  },
  setChangePass(context, payload) {
    context.commit("setChangePass", payload)
  }
}

const mutations = {
  setChangePass(state, payload) {
    window.localStorage.setItem('clientes-' + c.nombreCorto + '-cambiarPass', payload.cambiarPass);
    state.cambiarPass = payload.cambiarPass
  },
  setToken(state, payload) {
    window.localStorage.setItem('clientes-' + c.nombreCorto + '-token', payload.token);
    state.token = payload.token;
  },
  setLogged(state, payload) {
    state.logged = payload.logged;
  },
  setCredentials(state, payload) {
    console.log(payload);
    window.localStorage.setItem('clientes-' + c.nombreCorto + '-cambiarPass', payload.cambiarPass);
    window.localStorage.setItem('clientes-' + c.nombreCorto + '-token', payload.token);
    window.localStorage.setItem('clientes-' + c.nombreCorto + '-id', payload.id);
    window.localStorage.setItem('clientes-' + c.nombreCorto + '-nombre', payload.nombre);
    window.localStorage.setItem('clientes-' + c.nombreCorto + '-email', payload.email);
    window.localStorage.setItem('clientes-' + c.nombreCorto + '-logged', payload.logged);
    window.localStorage.setItem('clientes-' + c.nombreCorto + '-perfilUsuario', payload.perfilUsuario);

    state.cambiarPass = payload.cambiarPass;
    state.token = payload.token;
    state.id = payload.id;
    state.nombre = payload.nombre;
    state.email = payload.email;
    state.logged = payload.logged;
    state.perfilUsuario = payload.perfilUsuario;
  },

}

export default {
    state,
    getters,
    actions,
    mutations
}
